<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import DwxxbgsqBrowse from "./DwxxbgsqBrowse";
import DwxxbgsqEdit from "./DwxxbgsqEdit";
import DwxxbgsqForm from "./DwxxbgsqForm";
export default {
    name: "Dwxxbgsq",
    components: { DwxxbgsqBrowse, DwxxbgsqEdit, DwxxbgsqForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showForm: false
            }
        };
    },
    computed: {
        compName() {
            if (this.editProps.showEdit === true) {
                return "DwxxbgsqEdit";
            } else if (this.editProps.showForm === true) {
                return "DwxxbgsqForm";
            } else {
                return "DwxxbgsqBrowse";
            }
        }
    }
};
</script>
